import React, { useRef } from "react";
import {
  Box,
} from "@mui/material";

import LeftDrawer from "components/PageLayouts/Drawers/LeftDrawer";

const Files: React.FC = () => {
  
  const containerRef = useRef<HTMLElement>(null) as React.RefObject<HTMLElement>;

  return (
    <Box ref={containerRef} sx={{ position: "relative", width: "100%", height: "100%" }}>
      <LeftDrawer
        drawerContent={
            <h1>Left Drawer Content</h1>
        }
      />

      <h1>Files Page</h1>
    </Box>
  );
};

export default Files;
